import { Action } from "redux";
import { Feature } from "../../../core/geo/types";

export const SAVE_GEO_BORDERS = "SAVE_GEO_BORDERS";

export interface SaveGeoBordersAction extends Action {
    geoBorders: Feature[];
}

export const saveGeoBordersAction = (geoBorders: Feature[]): SaveGeoBordersAction => ({
    type: SAVE_GEO_BORDERS,
    geoBorders: geoBorders,
});
